
import { v4 as uuidv4 } from 'uuid';
import { ResellerPlanDetails } from './types';

export const defaultResellerPlan: ResellerPlanDetails = {
  id: uuidv4(),
  name: 'Reseller Pro',
  description: 'Professional reseller plan with white-labeled solution and revenue sharing',
  planType: 'reseller',
  setupFee: 500,
  annualPrice: 999,
  maxInstances: 10,
  maxManagers: 10,
  maxAdmins: 300,
  maxUsers: 25000,
  recommended: true,
  badgeText: 'POPULAR',
  planNumber: '67890',
  features: [
    { name: 'White-labeled instances', included: true, highlight: true },
    { name: 'Custom domain support', included: true },
    { name: 'Premium support', included: true, highlight: true },
    { name: 'Revenue sharing', included: true },
    { name: 'Marketing materials', included: true },
    { name: 'Unlimited admins', included: true },
    { name: 'Custom branding', included: true },
    { name: '24/7 technical support', included: true, highlight: true }
  ]
};

export const createEmptyPlan = (): ResellerPlanDetails => {
  return {
    id: uuidv4(),
    name: 'New Plan',
    description: 'Enter plan description',
    planType: 'reseller',
    setupFee: 99,
    annualPrice: 499,
    maxInstances: 1,
    maxManagers: 5,
    maxAdmins: 50,
    maxUsers: 1000,
    recommended: false,
    features: [
      { name: 'White-labeled instances', included: true },
      { name: 'Custom domain support', included: false },
      { name: 'Premium support', included: false },
      { name: 'Revenue sharing', included: true }
    ]
  };
};
